<app-details-page [loading]="loading$ | async"
                  [currentDate]="currentDate"
                  [combinedFacets]="combinedFacets$ | async"
                  [detailsPageSettings]="detailsPageSettings$ | async"
                  (onClose)="onClose()"
                  (onFavoriteToggle)="toggleFavorite($event)"
                  [favoritesProducts]="favoritesProducts$ | async"
                  [product]="product$ | async"
                  [selectedProductOrderHistory]="selectedProductOrderHistory$ | async"
                  [selectedProductBackorders]="selectedProductBackorders$ | async"
                  [allowOutOfStockOrdering]="allowOutOfStockOrdering"
                  [stock]="stock$ | async"
                  [skus]="skus$ | async"
                  [cartProducts]="cartProducts$ | async"
                  (onAddCart)="addCart($event)"
                  [quantityPicker]="quantityPicker$ | async"
                  [showSalesOrderPriceInfo]="showSalesOrderPriceInfo"
                  [canDownloadImage]="canDownloadImage">
</app-details-page>
